/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import SwiperCore, { Autoplay, Keyboard, Navigation } from 'swiper/core';
import { openCart } from '../modules/cart';
import { loadCartAmount } from '../modules/cart';

const nonce = window.nonce;
const Swiper = SwiperCore.use([Autoplay, Keyboard, Navigation]);

export function init() {
  const productSlider = new Swiper('[data-product-slider]', {
    autoHeight: true,
    navigation: {
      nextEl: '[data-product-slider-next]',
      prevEl: '[data-product-slider-prev]',
    },
    pagination: false,
  });

  const node = document.querySelector('[data-product-order]');

  if (!node) return;

  const options = node.querySelectorAll('[data-product-order-option]');
  const priceDisplay = node.querySelector('[data-product-order-price-display]');
  const submit = node.querySelector('[data-product-order-submit]');
  const quantityInput = node.querySelector('input[name="quantity"]');

  node.addEventListener('submit', handleSubmit.bind(true));

  options.forEach((option) => {
    option.addEventListener('click', handleChange.bind(true));
  });

  function handleChange(e) {
    const input = e.target;
    const { price } = input.dataset;

    priceDisplay.innerHTML = price;
  }

  function handleSubmit(event) {
    event.preventDefault();
    submit.blur();
    setLoader();

    const formData = Array.from(node.elements);

    // Collect only necessary inputs for add-to-cart, ignoring 'product'
    const elements = formData.filter(el => {
      if (!el.name || el.disabled) return false;
      if (el.type === 'button' || el.type === 'submit') return false;
      if (el.type === 'hidden' && el.name !== 'add-to-cart' && el.name !== 'variation_id') return false;
      if (!['INPUT', 'SELECT', 'TEXTAREA'].includes(el.tagName)) return false;
      if (el.name === 'product_id' || el.name === 'product') return false;
      return true;
    });

    let data = elements.map(el => ({
      name: el.name,
      value: (el.type === 'checkbox' || el.type === 'radio') ? (el.checked ? el.value : '') : el.value,
    })).filter(item => item.value !== '');

    // Rename add-to-cart to product_id and set correct value
    data.forEach(item => {
      if (item.name === 'add-to-cart') {
        item.name = 'product_id';
        const variationIdInput = node.querySelector('input[name="variation_id"]');
        item.value = (variationIdInput && variationIdInput.value) || submit.value;
      }
    });

    // if no variation_id get product_id from formdata
    if (!data.find(item => item.name === 'variation_id')) {
      data.push({
        name: 'product_id',
        value: formData.find(el => el.name === 'product_id').value,
      });
    }

    // If meters are being sent, ensure quantity is 1 (WooCommerce only supports whole numbers)
    const metersField = data.find(item => item.name === 'meters');
    if (metersField) {
      // Remove any existing quantity field
      data = data.filter(item => item.name !== 'quantity');
      // Add quantity = 1 for per-meter products
      data.push({
        name: 'quantity',
        value: '1',
      });
    } else {
      // If no quantity field exists, add default quantity
      if (!data.find(item => item.name === 'quantity')) {
        const quantityInput = formData.find(el => el.name === 'quantity');
        if (quantityInput) {
          data.push({
            name: 'quantity',
            value: quantityInput.value || '1',
          });
        } else {
          data.push({
            name: 'quantity',
            value: '1',
          });
        }
      }
    }

    $.ajax({
      type: 'POST',
      url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'),
      dataType: 'json',
      data: data,
      success: function () {
        openCart();
        loadCartAmount();
        resetLoader();
      },
      error: function (error) {
        resetLoader();
        const json = error && error.responseJSON ? error.responseJSON : null;
        const message = json && json.message ? json.message : 'Er is een fout opgetreden. Probeer het opnieuw.';
        const existingError = document.querySelector('.woocommerce-error');
        if (!existingError) {
          const errorMessage = document.createElement('div');
          errorMessage.classList.add('woocommerce-error');
          errorMessage.innerHTML = `<p>${message}</p>`;
          const variationAddToCart = document.querySelector('.woocommerce-variation-add-to-cart');
          const simpleAddToCart = document.querySelector('.woocommerce-add-to-cart');
          if (variationAddToCart) {
            variationAddToCart.insertAdjacentElement('beforebegin', errorMessage);
          }
          if (simpleAddToCart) {
            simpleAddToCart.insertAdjacentElement('beforebegin', errorMessage);
          }
          setTimeout(() => {
            errorMessage.remove();
          }, 5000);
        }


      },
    });
  }

  function setLoader() {
    submit.classList.add('is-loading');
    submit.disabled = true;
  }

  function resetLoader() {
    submit.classList.remove('is-loading');
    submit.disabled = false;
  }

  // variation change listener
  $('.single_variation_wrap').on('show_variation', function (event, variation) {
    handleShowVariation(event, variation);
  });

  function handleShowVariation(event, variation) {
    $('input[name="product"]').val('product-id-' + variation.variation_id);
    $('[data-product-order-price-display]').html('| ' + variation.price_html);

    $('[data-product-order-submit]').attr('disabled', false);

    const slide = $('.swiper-slide[data-image="' + variation.image_id + '"]').attr('data-index');
    productSlider.slideToLoop(slide, 400);

    $('html, body').animate({ scrollTop: 0 }, 400);
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/product-order.js